/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateGlobalMessageTemplateRequest } from '../models/CreateGlobalMessageTemplateRequest'
import type { GlobalMessageTemplateIndexResource } from '../models/GlobalMessageTemplateIndexResource'
import type { GlobalMessageTemplateResource } from '../models/GlobalMessageTemplateResource'
import type { MessagePreviewResource } from '../models/MessagePreviewResource'
import type { StoreGlobalMessageTemplateRequest } from '../models/StoreGlobalMessageTemplateRequest'

import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'

export class GlobalMessageTemplatesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Display a listing of the resource.
     * @returns any OK
     * @throws ApiError
     */
    public getGlobalMessageTemplates({
        name,
        category,
        type
    }: {
        /**
         * Name of the global message template filter.
         */
        name?: string
        /**
         * Category of the global message template filter.
         */
        category?: string
        /**
         * Type of the global message template filter.
         */
        type?: string
    }): CancelablePromise<{
        data: Array<GlobalMessageTemplateIndexResource>
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/messaging/global-message-templates',
            query: {
                name: name,
                category: category,
                type: type
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Store a newly created resource in storage.
     * @returns any Created
     * @throws ApiError
     */
    public createGlobalMessageTemplate({
        requestBody
    }: {
        requestBody: CreateGlobalMessageTemplateRequest
    }): CancelablePromise<{
        data: GlobalMessageTemplateResource
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/messaging/global-message-templates',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Display the specified resource.
     * @returns any OK
     * @throws ApiError
     */
    public getGlobalMessageTemplate({
        templateId
    }: {
        /**
         * The ID of the global message template.
         */
        templateId: string | number
    }): CancelablePromise<{
        data: GlobalMessageTemplateResource
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/messaging/global-message-templates/{template_id}',
            path: {
                template_id: templateId
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Remove the specified resource from storage.
     * @returns void
     * @throws ApiError
     */
    public deleteGlobalMessageTemplate({
        templateId
    }: {
        /**
         * The ID of the global message template.
         */
        templateId: string | number
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/messaging/global-message-templates/{template_id}',
            path: {
                template_id: templateId
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Update the specified resource in storage.
     * @returns any OK
     * @throws ApiError
     */
    public updateGlobalMessageTemplate({
        templateId,
        requestBody
    }: {
        /**
         * The ID of the global message template.
         */
        templateId: string | number
        requestBody: StoreGlobalMessageTemplateRequest
    }): CancelablePromise<{
        data: GlobalMessageTemplateResource
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/messaging/global-message-templates/{template_id}',
            path: {
                template_id: templateId
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Preview the specified resource.
     * @returns any OK
     * @throws ApiError
     */
    public previewGlobalMessageTemplate({
        templateId,
        rawContent
    }: {
        /**
         * The ID of the global message template.
         */
        templateId: string | number
        /**
         * Set to 1 to get raw content, if supported
         */
        rawContent?: number
    }): CancelablePromise<{
        data: MessagePreviewResource
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/messaging/global-message-templates/{template_id}/preview',
            path: {
                template_id: templateId
            },
            query: {
                raw_content: rawContent
            },
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }
}
